<template>
	<div class="layout-image">
		<div class="layout-image-wrap">
			<!--Event handler img-->
			<div class="layout-image-load">
				<form class="layout-upload-form">
					<!--upload image-->
					<input
							id="file-upload"
							type="file"
							name="file-upload"
							ref="input"
							accept="image/*"
							@change="setImage"
					/>

					<label for="file-upload" class="custom-file-upload">写真を選ぶ</label>
					<vue-cropper
							v-show="item.image_url"
							ref="cropper"
							class="crop-wrap"
							:src="item.image_url"
							:autoCropArea="1"
							:viewMode="3"
							:modal="false"
							:cropBoxMovable="true"
							:cropBoxResizable="false"
							:guides="false"
							:restore="false"
							:hightlight="false"
							:background="false"
							:zoomable="true"
							:toggleDragModeOnDblclick="false"
							:strict="false"

					/>

					<!--list button event handler image -->
					<div :class="{ hidden: selected }" id="btn-editor">
						<div class="btn-editor-img">
							<!--Zoom delete image-->
							<div class="btn" id="reset" @click="resetImage">
								<span>リセット</span>

								<i class="fa fa-repeat">
									<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-repeat"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
								</i>
							</div>

							<!--Upload new image-->
							<label class="btn" for="file-upload" id="upload">
								<span>アップロード</span>

								<i class="fa fa-upload">
									<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
								</i>
							</label>
						</div>
					</div>
				</form>
			</div>
			<!--/.Event handler img-->

			<!--Image text summary-->
			<div class="layout-image-summary">
				<div class="layout-image-summary-wrap">
					<div class="layout-image-summary-text"
							 :class="{'layout-image-summary-text-bold': item.isLarge }">
						<InputText
								:title="item.lead_sentence"
								:placeholder="placeholderLead"
								:max-length="176"
								:is-html="true"
								:field-name="'lead_sentence'"
								:character-a-column="44"
						/>
					</div>
				</div>
			</div>
			<!--/.Image text summary-->

			<!--Caption to image-->
			<div class="layout-image-caption">
				<div class="layout-image-caption-wrap">
					<div class="layout-image-caption-text">
						<InputText
								:title="item.image_caption"
								:placeholder="'絵解きを入力（４０文字以内）'"
								:max-length="40"
								:field-name="'image_caption'"
								:text-horizontal="true"
						/>
					</div>
				</div>
			</div>
			<!--/.Caption to image-->
		</div>
	</div>
</template>

<script>
	// supporter
	import VueCropper from 'vue-cropperjs'
	import 'cropperjs/dist/cropper.css'

	// Components
	import InputText from './InputText'

	// Mixins
	import ImageCropperMixin from '../../mixins/imageCropper.mixin'

	// Models
	import NewspaperModel from '../../models/newspaper.model'

	export default {
		name: 'ImageCropper',

		mixins: [
			ImageCropperMixin
		],

		components: {
			InputText,
			VueCropper
		},

		data () {
			return {
				selected: true,
				svgPlaceholder: `<svg width="45" height="29" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 35.91 30.66" style="enable-background:new 0 0 35.91 30.66;" xml:space="preserve"><style type="text/css">.st0{fill:#818A91;</style><g><path class="st0" d="M0.36,26.83h3.86V5.08H1.27v-2.3c1.44-0.56,2.51-0.91,3.33-2.1h1.2v26.17h3.62v3.02H0.36V26.83z"/><path class="st0" d="M20.4,3.77h-7.2v-3.1h9.02v2.26c-3.27,9.41-4.3,15.92-4.4,26.92h-1.68C16.36,18.58,17.63,11.99,20.4,3.77z"/><path class="st0" d="M34.46,5.91c-0.74-1.79-1.52-2.66-2.65-2.66c-1.68,0-3.62,2.94-3.76,12.31c0.92-2.26,2.03-3.85,3.46-3.85
		c2.18,0,4.05,2.86,4.05,8.93c0,6.15-1.84,9.69-4.16,9.69c-2.65,0-4.88-4.05-4.88-13.62c0-11.91,2.65-16.48,5.25-16.48
		c1.7,0,2.82,1.51,3.59,3.42L34.46,5.91z M34.07,20.72c0-4.21-1.23-6.19-2.75-6.19c-1.28,0-2.42,1.75-3.2,4.45
		c0.28,5.88,1.63,8.46,3.33,8.46C32.97,27.43,34.07,24.97,34.07,20.72z"/></g></svg>`
			}
		},

		computed: {
			item () {
				return NewspaperModel.query().find(1) || new NewspaperModel()
			},

			placeholderLead () {
				const isNowLarge = this.item.isLarge
				const wordCount = isNowLarge ? 102 : 176
				const fontSize = isNowLarge ? `大` : `小`
				return `リード文を入力（${fontSize}・最大 <div class='num'>${wordCount}</div>文字）`
			}
		},

		created () {
			setTimeout(() => {
				this.placeholderLead = `リード文を入力（小・最大<div class='num'>１７６</div>文字）`
			}, 500)
		},

		mounted() {
		  if(this.item.image_url) {
        this.selected = false;
			}
    }
  }
</script>

<style scoped lang="scss">
	.cropper-crop-box {
		width: 920px !important;
		height: 977px !important;
	}
</style>